import React, { useEffect, useState } from 'react'
import { UAParser } from 'ua-parser-js';
import InstagramLogo from '../../components/Elements/InstagramLogo';
import MessageBox from '../../components/Elements/MessageBox';

const ProfileRedirect = ({tag}) => {

    function detectOS() {
      var parser = new UAParser();
      var result = parser.getResult();
      var os = result.os.name;
      return os;
    }
    
    function openInstagramIOS(tag) {
      window.location.href = `instagram://explore/tags/${tag}`;
    }
    
    function openInstagramAndroid(tag) {
      window.location.href = `intent://www.instagram.com/explore/tags/${tag}#Intent;package=com.instagram.android;scheme=https;end`;
    }
    
    function openInstagramInBrowser(tag) {
      window.location.href = `https://www.instagram.com/explore/tags/${tag}`;
    }    

    const [currentMessage, setCurrentMessage] = useState("Hey there 👋")

    useEffect(() => {

        const os = detectOS();
        const messages = [];

        setTimeout(() => {
          switch (os) {
          
            case "Chromecast":
  
              setCurrentMessage("Looks like you're using a Chromecast device");
              setTimeout(() => {
                setCurrentMessage(`Opening #${tag} in your browser`);
                setTimeout(() => {
                  openInstagramInBrowser(tag)
                }, 200);
              }, 200);
              break;
            
            case "Mac OS":
  
              setCurrentMessage("Looks like you're using a Mac");
              setTimeout(() => {
                setCurrentMessage(`Opening #${tag} in your browser`);
                setTimeout(() => {
                  openInstagramInBrowser(tag)
                }, 200);
              }, 200);
              break;
            
            case "Windows":
  
              setCurrentMessage("Looks like you're using a Windows PC");
              setTimeout(() => {
                setCurrentMessage(`Opening #${tag} in your browser`);
                setTimeout(() => {
                  openInstagramInBrowser(tag)
                }, 200);
              }, 200);
              break;
            
            case "iOS":
  
              setCurrentMessage("Looks like you're using an iOS Device");
              setTimeout(() => {
                setCurrentMessage(`Opening #${tag} on Instagram App`);
                setTimeout(() => {
                  openInstagramIOS(tag)
                  setTimeout(() => {
                    messages.push("Looks like it did not work");
                    setTimeout(() => {
                      messages.push(`Opening #${tag} in your browser`);
                      openInstagramInBrowser(tag);
                    }, 300);
                  }, 1000);
                }, 200);
              }, 200);
              break;
            
            case "Android":
  
              setCurrentMessage("Looks like you're using an Android Device");
              setTimeout(() => {
                setCurrentMessage(`Opening #${tag} on Instagram App`);
                setTimeout(() => {
                  openInstagramAndroid(tag)
                  setTimeout(() => {
                    messages.push("Looks like it did not work");
                    setTimeout(() => {
                      messages.push(`Opening #${tag} in your browser`);
                      openInstagramInBrowser(tag);
                    }, 300);
                  }, 1000);
                }, 200);
              }, 200);
              break;
          
            default:
              setCurrentMessage("Looks like you're using a some out of this world device");
              setTimeout(() => {
                setCurrentMessage(`Opening #${tag} in your browser, hope it works`);
                setTimeout(() => {
                  openInstagramInBrowser(tag)
                }, 200);
              }, 200);
              break;
          }
        }, 300);

    }, [tag])
    

  return (
    <>
        
      <div className="w-screen h-screen top-0 fixed left-0 bg-white flex flex-col items-center justify-start">
        <div className="flex flex-col items-center mt-24">
          <InstagramLogo width="150" className="my-11" />
          <MessageBox currentMessage={currentMessage} />
        </div>
      </div>

    </>
  )
}

export default ProfileRedirect